import ProfileStatusMcom from './ProfileStatus.mcom';
import ProfileStatusBcom from './ProfileStatus.bcom';

export default import.meta.env.VITE_ENTRY_POINT === 'bcom' ? ProfileStatusBcom : ProfileStatusMcom;
